import { render } from "./apartment.svg?vue&type=template&id=3dbebeef"
const script = {}
script.render = render

export default script